import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/rubik-cyrillic-ext-normal-79891522.woff2%22,%22weight%22:%22300%20900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22ui%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0460-052F,%20U+1C80-1C8A,%20U+20B4,%20U+2DE0-2DFF,%20U+A640-A69F,%20U+FE2E-FE2F%22}]}],%22variableName%22:%22uiCyrillicExt%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'uiCyrillicExt'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
